import type { CSSProperties } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores'
import { ThemeToggle } from '@/components/shared/ThemeToggle'

export function AuthLayout() {
  const { tokens, isLoading } = useAuthStore()

  // Redirect authenticated users to dashboard
  if (!isLoading && tokens) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="hearth-canvas min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="absolute right-4 top-4">
        <ThemeToggle />
      </div>
      <div className="hearth-appear sm:mx-auto sm:w-full sm:max-w-md">
        <h1 className="text-center text-3xl font-serif font-bold text-primary-600">FamSteady</h1>
        <p className="mt-2 text-center text-sm text-gray-600">
          Peace of mind for family care
        </p>
      </div>
      <div className="hearth-appear mt-8 sm:mx-auto sm:w-full sm:max-w-md" style={{ '--stagger': 1 } as CSSProperties}>
        <div className="hearth-card-floating py-8 px-4 sm:px-10">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
